const timeDown  = {
  state: {
    timeCount: 180,
    time: null
  },
  mutations: {
    startCount(state, data) {
      // alert("开始喽");
      state.time = setInterval(() => {
      // console.log(state.timeCount );
        state.timeCount =state.timeCount - 1;
        if (state.timeCount === 0) {
          // alert("关闭喽");
        clearInterval(state.time);
        state.time = null;
        }
      }, 1000);
    },
    closeCount(state, data) {
      // alert("关闭喽");
      clearInterval(state.time);
      state.time = null;
    },
    setCount(state, data) {
      // alert("重置喽");
      state.timeCount = data;
    }
  }
};
export default timeDown;


